import { generatePath, generateRouteParams } from '@klp/routing';

import type { FileRequestParams } from './FileRequestParams';
import type { IFileObject } from './IFileObject';

export class FileObject implements IFileObject {
    public static toBinaryFile = (file: FileObject): Partial<FileObject> => ({
        type: file.type,
        fileContent: file.fileContent
            ? file.fileContent.toString().replace(/^data:(.*,)?/, '')
            : '',
        fileName: file.fileName,
    });

    public id: string | number;

    public type?: string;
    public fileName?: string;
    public fileContent?: string;
    public fileContentBlob?: Blob | string;
    public filePath?: string;

    public queueName?: string;
    public imageParams?: FileRequestParams;

    public local?: boolean;
    public toDelete?: boolean;
    public pathIndex?: string;
    public bucketPath?: string;

    public constructor(params: IFileObject) {
        Object.assign(this, params);
        this.local = params.local || false;
        this.toDelete = params.toDelete || false;
        this.pathIndex = generatePath(
            params.queueName,
            params.bucketPath,
            params.fileName,
        );
        if (params.imageParams) {
            this.pathIndex = generatePath(
                params.queueName,
                params.bucketPath,
                params.fileName,
                generateRouteParams(params.imageParams),
            );
        }
        if (!params.fileName && params.bucketPath) {
            const parts = params.bucketPath.split('/');
            this.fileName = parts[parts.length - 1];
        }

        if (!this.id && this.fileName) {
            this.id = this.fileName;
        }
    }

    public static parseObject(obj: IFileObject): FileObject {
        try {
            return new FileObject(obj);
        } catch (error) {
            throw new Error(`Could not parse object : ${JSON.stringify(obj)}`);
        }
    }
}
